import { useQuery } from '@tanstack/react-query';

import { Site } from 'src/features/sites/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/site/:siteId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    siteId: string;
    parkingId: string;
}
const queryFn = ({ siteId, parkingId }: DTO): Promise<Site> => {
    return axios.get(formatResourcePath(RESOURCE, { siteId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetSite };
